import React, { useState, useEffect } from "react"
import styled from "styled-components"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"
import ResultCard from "@/containers/MoneyFortune/View/result/ResultCard"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Result() {
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "Bitcoin"
    })[0]

    setResultPageDate(resultfilter)
  }, [])

  return (
    <Wrapper>
      <MetaData
        title={`我的代表人物是 神秘紙上富翁 - 中本聰 `}
        description="你對於自己的目標十分清晰，一旦下定決心就會付出全力執行，是少見的做策略高手，賺錢對你來說，從來都不是難事，從失敗的經驗獲得養份，更新的思路去達到更高領域。"
        url={`https://www.kryptogo.com/money-fortune/Bitcoin`}
        image="https://i.ibb.co/6vn9ryX/OG-Zong-Ben-Cong.webp"
      />
      <ResetCSS />
      <ResultCard
        key={resultPageData.roleID}
        name={resultPageData.name}
        AKA={resultPageData.AKA}
        chance={resultPageData.chance}
        saying={resultPageData.saying}
        summary={resultPageData.summary}
        analysis={resultPageData.analysis}
        investment={resultPageData.investment}
        befit={resultPageData.befit}
        img={resultPageData.img}
        type="share"
        GetAndShare={GetAndShare}
        API={GetAndShare.API}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
